import { Modal, Button, Icon } from "@plum-xoxo/admin-dsm";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import React, { Component } from "react";

class DeleteUserConfirmation extends Component {
  render() {
    const { closeModal, toBeRemovedUser, removeUser } = this.props;
    return (
      <>
        <Modal
          isOpen={true}
          size="sm"
          onClose={() => {
            closeModal();
          }}
        >
          <div className="d-flex justify-content-between">
            <Typography.H2>Are you sure?</Typography.H2>
            <Icon
              iconName="Close"
              size="12"
              color="dark"
              shade="c200"
              className="cursor-pointer"
              onClick={() => {
                closeModal();
              }}
            />
          </div>
          <Typography
            style={{ marginTop: "12px", marginBottom: "32px" }}
            color="dark"
            shade="c200"
            className="text-break"
          >
            You are about to remove{" "}
            <Typography component="span" className="text-break">
              {toBeRemovedUser.name}
            </Typography>{" "}
            from your recipient list. Do you want to proceed?
          </Typography>
          <div className="d-flex" style={{ justifyContent: "flex-end" }}>
            <Button
              className="mr-12"
              variant="plain"
              color="primary"
              onClick={() => closeModal()}
            >
              No, Cancel
            </Button>
            <Button
              color="primary"
              onClick={() => {
                removeUser();
              }}
            >
              Yes, Remove
            </Button>
          </div>
        </Modal>
      </>
    );
  }
}

export default DeleteUserConfirmation;
